<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin">
            <span class="loader">
                <span>{{ $spinnerText }}</span>
            </span>
        </div>
    </Transition>

    <v-form :name="props.formProps.formName">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
                <Tab value="1">{{ __('Changelog') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormSelect fieldName="user_id"
                                    label="User"
                                    size="8"
                                    validation="required"
                                    :isFormDisabled="isFormDisabled"
                                    :isFocus="true"
                                    :options="select?.users"
                                    v-model:field="crud.user_id" />

                        <FormSelect v-if="formProps.addMode !== true"
                                    fieldName="status_id"
                                    label="Status"
                                    size="4"
                                    :isFormDisabled="isFormDisabled"
                                    :options="select?.statuses"
                                    v-model:field="crud.status_id" />

                        <FormStaticText v-else
                                        size="4" />
                    </div>
                    <div class="grid">
                        <FormSelect fieldName="dcttype_id"
                                    label="Alert type"
                                    size="3"
                                    validation="required"
                                    :isFormDisabled="isFormDisabled"
                                    :options="select?.dct_alert_types"
                                    v-model:field="crud.dcttype_id" />

                        <FormSelect fieldName="source_table"
                                    label="Source table"
                                    size="3"
                                    validation="required"
                                    :isFormDisabled="isFormDisabled"
                                    :options="select?.alert_tables"
                                    v-model:field="crud.source_table" />

                        <FormInputNumber fieldName="source_id"
                                         label="Source ID"
                                         size="2"
                                         validation="required"
                                         :minFractionDigits="0"
                                         :maxFractionDigits="0"
                                         :isFormDisabled="isFormDisabled"
                                         v-model:field="crud.source_id" />

                        <FormCalendar fieldName="show_alert_date"
                                      label="Show alert date"
                                      size="2"
                                      validation="required"
                                      showTime
                                      hourFormat="24"
                                      dateFormat="yy-mm-dd"
                                      :isFormDisabled="isFormDisabled"
                                      v-model:field="crud.show_alert_date" />

                        <FormCalendar fieldName="change_status_date"
                                      label="Status change date"
                                      size="2"
                                      showTime
                                      hourFormat="24"
                                      dateFormat="yy-mm-dd"
                                      :isFormDisabled="true"
                                      v-model:field="crud.change_status_date" />

                    </div>
                    <div class="grid">
                        <FormEditor fieldName="message"
                                    label="Message"
                                    validation="required"
                                    :isFormDisabled="isFormDisabled"
                                    v-model:field="crud.message" />
                    </div>
                </TabPanel>

                <TabPanel v-if="crud.log"
                          value="1"
                          :pt="{ root: { class: 'form-tab-panel' } }">
                    <ChangeLog :log="crud?.log" />
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <FormButtons :formProps="props.formProps"
                         :sourceForm="crud"
                         :validation="validation"
                         v-model:isFormDisabled="isFormDisabled">
            </FormButtons>
        </div>
    </v-form>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import { validation, initFormObj } from '@pages/Helper/crud_utils.js'
import FormInputText from '@crud/FormInputText.vue'
import FormInputNumber from '@crud/FormInputNumber.vue'
import FormSelect from '@crud/FormSelect.vue'
import FormStaticText from '@crud/FormStaticText.vue'
import FormCalendar from '@crud/FormCalendar.vue'
import FormEditor from '@crud/FormEditor.vue'
import FormButtons from '@crud/FormButtons.vue'
import ChangeLog from '@crud/ChangeLog.vue'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
})

const isLoading = ref(true);
const isFormDisabled = ref(true)
const crud = ref({})

const options = ["statuses", "users", "dct_alert_types", "alert_tables"];
const select = ref(null);

// -----------------------------------------------------

onMounted(async () => {
    const params = { props, crud, isLoading, options, select, paramsToSelect: { 'statuses': { 'status_category': 'STA_ALERT' } } }
    await initFormObj(params)
})

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
